export function buildSmsPrefill(greeting?: string | null, footer?: string | null): string {
  const parts: string[] = []
  if (greeting) parts.push(greeting)
  if (footer) parts.push(footer)
  return parts.join('\n\n')
}
